import React, { Component } from "react";
import {withRouter} from "react-router-dom";
import auth from './auth';

class Callback extends Component {
  async componentDidMount() {
    await auth.handleAuthentication();
    window.location.replace(process.env.REACT_APP_HIVE_UI);
  }
  render() {
    const style = {
      position: "absolute",
      display: "flex",
      justifyContent: "center",
      height: "100vh",
      width: "100vw",
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      backgroundColor: "white"
    };

    return<div style={style} />;
  }
}

export default withRouter(Callback);
